import { useContext } from "react";
import { StoreContext } from "../store/Store";
import { GlobalRefContext } from "../store/GlobalRefs";
import { actionTypes } from "../store/storeTypes";
import UndoSVG from "../images/svg/Undo";

export const Undo = ({ data }) => {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const { nodes, flowConfig } = store;

  const style = {
    position: "absolute",
    right: flowConfig.undoButtonRight,
    top: flowConfig.undoButtonTop,
    padding: flowConfig.undoButtonPadding,
    backgroundColor: flowConfig.undoButtonBackgroundColor,
    border: `${flowConfig.undoButtonBorderWidth}px solid ${flowConfig.undoButtonBorderColor}`,
    borderRadius: flowConfig.undoButtonBorderRadius,
    cursor: "pointer",
  };

  const dragNodeStyle = {
    fontSize: flowConfig.dragNodeFontSize,
    fontWeight: flowConfig.dragNodeFontWeight,
    backgroundColor: flowConfig.dragNodeBackgroundColor,
    border: `${flowConfig.dragNodeBorderWidth}px solid ${flowConfig.dragNodeBorderColor}`,
    borderRadius: flowConfig.dragNodeBorderRadius,
    paddingTop: flowConfig.dragNodePaddingV,
    paddingBottom: flowConfig.dragNodePaddingV,
    paddingLeft: flowConfig.dragNodePaddingH,
    paddingRight: flowConfig.dragNodePaddingH,
    lineHeight: `${flowConfig.dragNodeLineHeight / 10}em`,
    color: flowConfig.dragNodeTextColor,
    width: flowConfig.dragNodeWidth,
  };

  const onClick = () => {
    const myNode = nodes.find((node) => node.id === data.id);

    const newNode = {
      id: "floatNode",
      data: {
        label: <div>Drag me to the last node you want to keep.</div>,
        style: dragNodeStyle,
      },
      position: {
        x:
          myNode.position.x +
          myNode.measured.width +
          flowConfig.dragNodeMarginLeft,
        y: myNode.position.y,
      },
      //   width: flowConfig.dragNodeWidth,
      type: "DragNode",
      draggable: true,
      hidden: false,
    };

    //add to nodes
    let newNodes = [];
    if (nodes.findIndex((node) => node.id === "floatNode") !== -1) {
      //update if exists
      newNodes = nodes.map((node) => {
        if (node.id === "floatNode") {
          return newNode;
        }
        return node;
      });
    } else {
      //add the node
      newNodes = nodes.concat(newNode);
    }
    grefs.dragNode.current = { node: null, action: "add" };
    grefs.ignoreNodeChange.current = true;
    grefs.dragNodeParent.current = myNode.id;
    dispatch({ type: actionTypes.SET_NODES, payload: newNodes });
  };
  return flowConfig ? (
    <div title="Click to undo" onClick={() => onClick()} style={style}>
      <UndoSVG
        height={flowConfig.undoButtonHeight}
        width={flowConfig.undoButtonWidth}
        fill={flowConfig.undoButtonIconColor}
      />
    </div>
  ) : null;
};
